import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { UIVersionProvider } from './context/UIVersionContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UIVersionProvider>
      <App />
    </UIVersionProvider>
  </React.StrictMode>
);
